<div class="eforall-common-field form-floating">

	@let currentField = field();
	@let state = currentField.formField();
	@let validations = currentField.validations;

	<kendo-dropdownlist class="form-control form-kendo-dropdownlist"
		[id]="randomId"
		[data]="options()"
		[defaultItem]="defaultItem"
		textField="text"
		valueField="value"
		[itemDisabled]="isItemDisabled"
		[valuePrimitive]="true"
		[value]="state.value()"
		[disabled]="state.disabled()"
		(valueChange)="state.value.set($event); state.markAsTouched()"
		(blur)="state.markAsTouched()">

		<ng-template kendoDropDownListItemTemplate let-dataItem>
			@if(dataItem.icon){<i [class]="dataItem.icon"></i> } {{ dataItem.text }}
		</ng-template>
		<ng-template kendoDropDownListValueTemplate let-dataItem>
			@if(dataItem?.icon){<i [class]="dataItem.icon"></i> } {{ dataItem?.text }}
		</ng-template>

	</kendo-dropdownlist>

	<label [for]="randomId" class="color-gray d-flex">
		{{ displayLabel() }}
		@if (!validations || !validations.isRequired?.()) {
		<span class="ps-1">(optional)</span>
		}
	</label>

	@if (state.touched() && state.invalid()) {
	<div class="error-message" role="alert">
		@for (error of state.errors(); track error) {
		<div class="color-darkred text-end" style="font-size: 14px">{{ error.message }}</div>
		}
	</div>
	}
</div>